import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import P2TrackerItem from "./P2TrackerItem";
import Check from "../../resources/Check";
import Dots from "../../resources/Dots";
import Exclamation from "../../resources/Exclamation";

function P2Tracker({ data }) {
  const { application_status, current_stage, stages } = data;

  const [icon, setIcon] = useState()
  
  useEffect(() => {
    if (application_status.icon === "pending") {
      application_status.label ??= "Application is pending"
      setIcon(<Dots />)
    } else if (application_status.icon === "success") {
      application_status.label ??= "Application is now successfully completed"
      setIcon(<Check />)
    } else if (application_status.icon === "warning") {
      application_status.label ??= "Application is rejected"
      setIcon(<Exclamation />)
    }
  }, [application_status])
  // application_status, an object, is passed directly as a dependency for useEffect.
  // This will cause the useEffect to run on every rerender even if application_status' values remain the same.
  // But because the useEffect is quite light, this should not be a problem.

  return (
    <div className="polymer-tracker__container">
      {stages.map((stage, index) => {
        const isActive = index <= current_stage - 1;
        return <P2TrackerItem stage={stage} isActive={isActive} />;
      })}
      <>
        <div className={`polymer-tracker-item__result-icon polymer-tracker-item__result-icon-${application_status.icon}`}>
          {icon}
        </div>
        <span className={`polymer-tracker-item__result-text polymer-tracker-item__result-text-${application_status.icon}`}>{application_status.label}</span>
      </>
    </div>
  );
}

P2Tracker.propType = {
  data: PropTypes.shape({
    application_status: PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.oneOf(["pending", "success", "warning"]).isRequired,
    }).isRequired,
    current_stage: PropTypes.number.isRequired, // Starts from 0
    stages: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        description: PropTypes.string,
        link: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
};

export default P2Tracker;

// {
//   application_status: {
//       label: 'Application is pending'
//       icon: '' // error | warning | success | pending
//   },
//   current_stage: 1,
//   stages: [
//       {
//           label: '',
//           description: '',
//           link: ''
//       }
//   ]
// }
